import cls from 'classnames';
import { useCallback, memo, useEffect, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';

import FooterRelevantLinks from '../FooterRelevantLinks';
import formatForAnalytics from '../../../utils/formatForAnalytics';
import theme from '../../../styles/theme';

import { LinkBatch } from './LinkBatch';
import { StoreLinks } from './StoreLinks';
import { CATEGORY_LINKS, TERMS_LINKS } from './config';
import { SingleToolFooterProps } from './types';
import useStyles from './style';

const COPY_TEXT = `© ${new Date().getFullYear()} PicsArt, Inc.`;

function SingleToolFooter({ className, analytics, pageName = 'homepage' }: SingleToolFooterProps) {
  const [isExpandable, setIsExpandable] = useState(false);
  const onClick = useCallback(
    (text: string) => {
      analytics.footerLinkClicked(formatForAnalytics(text), pageName);
    },
    [analytics, pageName],
  );
  const { width } = useWindowSize();
  const classes = useStyles({ isExpandable });

  useEffect(() => {
    setIsExpandable(width <= theme.breakpoints.tablet);
  }, [width]);

  return (
    <>
      <FooterRelevantLinks analytics={analytics} pageName={pageName} />
      <footer className={cls(classes.root, className)}>
        <div className={classes.row}>
          <StoreLinks onClick={onClick} />
          <div className={classes.full}>
            {CATEGORY_LINKS.map((item) => (
              <LinkBatch
                {...item}
                analytics={analytics}
                key={item.title}
                onClick={onClick}
                isExpandable={isExpandable}
                isLast={false}
                pageName={pageName}
              />
            ))}
          </div>
        </div>

        <div className={isExpandable ? classes.termContainer : classes.termContainerLast}>
          <LinkBatch
            {...TERMS_LINKS}
            analytics={analytics}
            isExpandable={isExpandable}
            isLast={true}
            onClick={onClick}
            pageName={pageName}
          />
          <div className={cls(isExpandable && classes.copyText, classes.copy)}>{COPY_TEXT}</div>
        </div>
      </footer>
    </>
  );
}

export default memo(SingleToolFooter);
